// extracted by mini-css-extract-plugin
export default {"nav":"ResultListHeader-module__nav__l5vhGqt"};